import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgToolbarScale = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.5 1.5H12.5V12.5H7.5V7.01946L9.37614 5.24942L10.2324 6.18054L11.2682 2.8749L7.88753 3.63076L8.69917 4.51331L6.59338 6.5H1.5V1.5ZM1.5 7.5V12.5H6.5V7.5H1.5ZM0.5 6.5V0.5H13.5V13.5H7.5H0.5V6.5Z"
	})]
});
export default SvgToolbarScale;
